import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNrday70 } from './pages'

type TIdToPageMapWoofzNrday70 = Record<PageIdWoofzNrday70, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NRDAY_70: TIdToPageMapWoofzNrday70 = {
  [PageId.SUBSCRIPTIONS_NRDAY_70_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/subscriptions/SubscriptionNrday70'
      ).then((m) => ({
        default: m.SubscriptionsNrday70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/subscriptions/SubscriptionNrday70'
      ),
  },
  [PageId.CHAT_UPSELL_NRDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NRDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/upsell/Upsell'),
  },
  [PageIdWoofzNrday70.DOWNLOAD_NRDAY_70]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_70/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNrday70.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
